export default __webpack_public_path__ + "static/media/music.7bf79b81.svg";